import { Injectable, inject } from '@angular/core';
import { QBService } from '@services/qb.service';
import { SecurityContextService } from '@services/security_context.service';

@Injectable({
  providedIn: 'root',
})
export class SyncWorkerSettingService {
  private readonly qbService = inject(QBService);
  private readonly securityContextService = inject(SecurityContextService);

  private rememberedAnswer: Promise<boolean> | undefined;
  private rememberedForLoginToken: string | undefined;

  isAccountOnSyncWorker(): Promise<boolean> {
    const loginToken = this.securityContextService.authData().token;

    if (!this.rememberedAnswer || loginToken !== this.rememberedForLoginToken) {
      this.rememberedForLoginToken = loginToken;
      this.rememberedAnswer = this.qbService
        .getSyncWorkerEnabled()
        .catch((error) => {
          this.rememberedAnswer = undefined;
          throw error;
        });
    }

    return this.rememberedAnswer;
  }
}
